import React from 'react';
import { IParticipantsPair } from 'twain-sport-fe-mono/interfaces';
import { translationProvider } from '../../store/translations';
import { EMPTY_SPACE } from '../../constants/textSymbols';
import { Participants } from '../Participants';
import { PlayersInfoGrid } from '../PlayersInfoGrid';
import classes from './VideoPlayersIntro.module.scss';

interface IProps {
    tournamentName: string;
    stage: string;
    participants: IParticipantsPair;
}

export const VideoPlayersIntro: React.FC<IProps> = (props) => (
    <>
        <div className={classes.head}>
            <div className={classes.title}>{props.stage}</div>
            <div className={classes.info}>
                {translationProvider.string('tournament')}
                {EMPTY_SPACE}
                {props.tournamentName}
            </div>
        </div>
        <Participants live={false} withAvatar={false} participants={props.participants} onVideo />
        <div className={classes.body}>
            <PlayersInfoGrid participants={props.participants} />
        </div>
    </>
);
